import { apiGet, apiPost, apiPatch } from './httpClient'

export async function listSettings(params = {}, signal) {
  const query = new URLSearchParams(params).toString()
  const data = await apiGet(`/settings/${query ? `?${query}` : ''}`, { signal })
  return Array.isArray(data) ? data : (data.results || [])
}

export async function getSetting(key, signal) {
  const rows = await listSettings({ key }, signal)
  return rows[0] || null
}

export async function upsertSetting(key, value) {
  const existing = await getSetting(key)
  if (existing) {
    return apiPatch(`/settings/${existing.id}/`, { key, value })
  }
  return apiPost('/settings/', { key, value })
}
